import { useDeadAirAssist } from "./useDeadAirAssist";

/**
 * Renderless mount point for the dead-air speculative assist. It runs the detector, which watches the
 * live voice transcript and — on a configured silence gap — silently asks Expert Assist to classify the
 * pause, surfacing a single proactive suggestion only when it is a fillable, high-confidence lookup.
 * Everything else (detection, the GAIA round-trip, telemetry) is invisible to the expert.
 */
export function DeadAirAssist(): null {
    useDeadAirAssist();
    return null;
}
